import { useSearch } from '@tanstack/react-router'

import { InsertForm } from '../components/insert-form'
import { List } from '../components/list'

export const DemoListPage = () => {
  const { activeCardId, word } = useSearch({ from: '/demo/_layout/list' })

  return (
    <>
      <InsertForm className="order-2" word={word} />
      <List activeCardId={activeCardId} className="order-1 min-h-0 grow" />
    </>
  )
}
